/**
 * Action Actions
 */
export const DEPENDENCY_ACTIONS = {
  DEPENDENCY_GRAPH_FOUND: 'DEPENDENCY_GRAPH_FOUND',
  CLEAR_DEPENDENCY_GRAPH: 'CLEAR_DEPENDENCY_GRAPH'
};

export interface IDependencyAction {
  type: string,
  addDependencyGraphPayload?: {
    registryName: string,
    entityVersion: string,
    entityStatus: string,
    isDependencyGraphFound: boolean
  }
}

export interface IDependencyState {
  registryName: string,
  entityVersion: string,
  entityStatus: string,
  isDependencyGraphFound: boolean
}

export const dependencyGraphInitialState: IDependencyState = {
  registryName: '',
  entityVersion: '',
  entityStatus: '',
  isDependencyGraphFound: false
};

export const getDependencyGraphStateReducer = (state: IDependencyState, action: IDependencyAction): IDependencyState => {
  switch (action.type) {
    case DEPENDENCY_ACTIONS.DEPENDENCY_GRAPH_FOUND: {
      return {
        ...state,
        registryName: action.addDependencyGraphPayload?.registryName ? action.addDependencyGraphPayload?.registryName : '',
        entityVersion: action.addDependencyGraphPayload?.entityVersion ? action.addDependencyGraphPayload?.entityVersion : '',
        entityStatus: action.addDependencyGraphPayload?.entityStatus ? action.addDependencyGraphPayload?.entityStatus : '',
        isDependencyGraphFound: action.addDependencyGraphPayload?.isDependencyGraphFound !== undefined ? action.addDependencyGraphPayload?.isDependencyGraphFound : false
      };
    }
    case DEPENDENCY_ACTIONS.CLEAR_DEPENDENCY_GRAPH: {
      return {
        ...state,
        registryName: '',
        entityVersion: '',
        entityStatus: '',
        isDependencyGraphFound: false
      };
    }
    default:
      return state;
  }
};
